import type { JsonSchema } from '@jsonforms/core';
import type { Layout } from '@jsonforms/core/src/models/uischema';
import { useJsonForms, JsonFormsDispatch } from '@jsonforms/react';

export interface RenderChildrenProps {
    layout: Layout;
    schema: JsonSchema;
    className?: string;
    path: string;
    enabled: boolean;
}

export const RenderChildren = ({ layout, schema, className, path, enabled }: RenderChildrenProps) => {
    const forms = useJsonForms;

    if (!layout.elements.length) {
        return [];
    }

    const { renderers, cells } = forms();

    return layout.elements.map((child, index) => {
        return (
            <div className={className} key={`${path}-${index}`}>
                <JsonFormsDispatch
                    renderers={renderers}
                    cells={cells}
                    uischema={child}
                    schema={schema}
                    path={path}
                    enabled={enabled}
                />
            </div>
        );
    });
};
